import React from "react";

const FeeScreen = () => {
    const pageStyle = {
        margin: "50px auto",
    } as React.CSSProperties;

    return (
        <div style={pageStyle}>
            <div>
                <b>Fee Policy</b>
            </div>
        </div>
    );
};

export default FeeScreen;
